<ng-container *ngIf="boca">
    <div class="row">
        <div class="col-6 boca-left">
            <div class="row">
                <div class="offset-4"></div>
                <div class="col-1 boca-top" *ngFor="let diente of boca.tl; let i=index">
                    <app-diente [disabled]="disabled" [diente]="diente" (dienteSelected)="dienteSelected($event)"></app-diente>
                </div>
            </div>
        </div>
        <div class="col-6 boca-right">
            <div class="row">
                <div class="col-1 boca-top" *ngFor="let diente of boca.tr">
                    <app-diente [disabled]="disabled" [diente]="diente" (dienteSelected)="dienteSelected($event)"></app-diente>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-6 boca-left">
            <div class="row">
                <div class="offset-4"></div>
                <div class="col-1 boca-bottom" *ngFor="let diente of boca.bl">
                    <app-diente [disabled]="disabled" [diente]="diente" (dienteSelected)="dienteSelected($event)"></app-diente>
                </div>
            </div>
        </div>
        <div class="col-6 boca-right">
            <div class="row boca-bottom">
                <div class="col-1" *ngFor="let diente of boca.br">
                    <app-diente [disabled]="disabled" [diente]="diente" (dienteSelected)="dienteSelected($event)"></app-diente>
                </div>
            </div>
        </div>
    </div>
</ng-container>